var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebDriver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4283_24381",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0096 9.40797C10.3424 9.40797 10.5984 9.67689 10.592 10.0097C10.592 10.3297 10.3232 10.5856 10.0032 10.5856C9.6832 10.5856 9.42078 10.3233 9.42078 10.0033C9.42078 9.67048 9.68321 9.40797 10.0096 9.40797ZM10.0224 8.23687C9.04322 8.23687 8.2496 9.01126 8.2432 9.98406C8.2432 10.9633 9.024 11.7569 9.9968 11.7569C10.9632 11.7569 11.7568 10.9823 11.7632 10.0159C11.7696 9.03674 10.9952 8.24327 10.0224 8.23687ZM10.0224 5.86234C12.0192 5.89434 13.9264 6.27202 15.6992 7.21922C15.84 7.29602 15.9296 7.39202 15.9872 7.53922C16.5184 8.87042 16.6144 10.2271 16.2752 11.6159C16.2368 11.7631 16.1728 11.808 16.032 11.8272C15.2 11.9232 14.4192 12.1664 13.7216 12.64C12.6592 13.3696 12.1088 14.4128 11.8784 15.648C11.8656 15.7248 11.8528 15.8016 11.84 15.8784C11.7952 16.2304 11.7952 16.2304 11.456 16.3072C10.4192 16.544 9.39517 16.5247 8.36477 16.2623C8.24317 16.2303 8.19843 16.1793 8.18563 16.0577C8.08962 15.2129 7.8464 14.4127 7.36 13.7087C6.6368 12.6528 5.59357 12.1088 4.36477 11.872C4.28797 11.8592 4.21117 11.8464 4.13438 11.8336C3.76318 11.7824 3.7632 11.7889 3.68 11.4241C3.3856 10.0737 3.49435 8.76157 4.03195 7.48797C4.07035 7.39197 4.16002 7.28964 4.25602 7.24484C5.54242 6.54084 6.93118 6.13766 8.38398 5.97766C8.92798 5.92006 9.47202 5.90074 10.016 5.86234H10.0224ZM10.0224 2.34875C5.83042 2.31675 2.36802 5.75366 2.34242 9.97766C2.32322 14.1697 5.74077 17.6064 9.96477 17.6448C14.1568 17.6832 17.6192 14.2399 17.6448 10.0159C17.6704 5.82394 14.2464 2.38715 10.0224 2.34875ZM10.6176 0C10.6688 0.0128 10.72 0.0256312 10.7712 0.0320312C11.2832 0.108831 11.808 0.159956 12.3072 0.275156C16.16 1.15836 19.1872 4.37756 19.84 8.27516C19.904 8.63996 19.9424 9.00474 19.9936 9.37594V10.6241C19.9808 10.6753 19.968 10.7265 19.9616 10.7777C19.8912 11.2385 19.8528 11.7056 19.7568 12.1664C18.9568 16.0448 15.6416 19.2192 11.7376 19.8464C11.3664 19.904 10.9952 19.9488 10.6176 20H9.36961C9.32481 19.9872 9.27996 19.9744 9.24156 19.968C8.78716 19.904 8.32635 19.8593 7.87195 19.7697C3.99355 18.9953 0.787194 15.6609 0.153594 11.7633C0.0895937 11.3857 0.0512 11.0081 0 10.6241V9.37594C0.064 8.93434 0.108753 8.48644 0.191953 8.04484C0.934353 4.06404 4.26242 0.806394 8.25602 0.153594L8.62719 0.0959375L9.37602 0H10.624H10.6176Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4283_24381)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4283_24381",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -530,
    y: -75,
    width: 848,
    height: 635
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317.67 -74.7188H-529.44V559.438H317.67V-74.7188Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4283_24381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.595 -0.59375H-0.582581V20.5837H20.595V-0.59375Z",
    fill: "#65707B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDriver);
export default ForwardRef;